import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

const CtaLarge = ({ text, to, state }) => {
  return (
    <Link to={to ? to : "#"} state={state ?? state} className="cta-lg">
      <span>{text}</span>
      <i>
        <Icon icon="ep:arrow-right" />
      </i>
    </Link>
  );
};

export default CtaLarge;
